export default __webpack_public_path__ + "static/media/CreatorType_icon.13015a95.svg";